module.exports = __webpack_public_path__ + "static/media/Vh.02a4a4b7.png";